
(function(){
if(window.__lmkLPInit){return;}window.__lmkLPInit=true;

/* =========================================================================
   HMP Lightning MK.II landing page — interactions
   Structure mirrors the FLASH landing page so the two stay maintainable
   together. Simplified where the MK.II is genuinely simpler: one battery,
   one charger, one price — so there is no SKU matrix, only colour + add-ons.
   ========================================================================= */

var BIKE_PRICE   = 3999;
var BIKE_COMPARE = 4499;

function money(v){return '$'+Number(v).toLocaleString('en-US');}
function inchesToText(inches){var feet=Math.floor(inches/12);return feet+"'"+(inches%12)+'"';}
function setRangeVisual(input){
  if(!input) return;
  var min=Number(input.min||0), max=Number(input.max||100), value=Number(input.value||0);
  input.style.setProperty('--pct', ((value-min)/(max-min))*100+'%');
}

/* ---------------------------------------------------------------- colours */
/* ---------------------------------------------------------------- colours */
/* ---------------------------------------------------------------- colours */
/* Split and per-image angle both come from the product media alt text in Shopify
   ("black motorcycle front view" etc.), not from guesswork. Order is
   main / side / front / back for both colours. */
var COLOR_GALLERY={
  Black:[
    {src:'https://cdn.shopify.com/s/files/1/0600/1629/6074/files/ChatGPT_Image_Jun_22_2026_04_00_23_PM_2.webp?v=1782115573',alt:'HMP Lightning MK.II in Black, main three-quarter view'},
    {src:'https://cdn.shopify.com/s/files/1/0600/1629/6074/files/ChatGPT_Image_Jun_22_2026_04_00_22_PM_1.webp?v=1782115574',alt:'HMP Lightning MK.II in Black, side view'},
    {src:'https://cdn.shopify.com/s/files/1/0600/1629/6074/files/LightningMK_Black03.webp?v=1781579237',alt:'HMP Lightning MK.II in Black, front view'},
    {src:'https://cdn.shopify.com/s/files/1/0600/1629/6074/files/Clipboard-2026-06-2216.29.53.webp?v=1785405074',alt:'HMP Lightning MK.II in Black, rear view'}
  ],
  Gray:[
    {src:'https://cdn.shopify.com/s/files/1/0600/1629/6074/files/ChatGPT_Image_Jun_22_2026_03_54_26_PM_2.webp?v=1782115573',alt:'HMP Lightning MK.II in Gray, main three-quarter view'},
    {src:'https://cdn.shopify.com/s/files/1/0600/1629/6074/files/ChatGPT_Image_Jun_22_2026_03_54_25_PM_1.webp?v=1782115574',alt:'HMP Lightning MK.II in Gray, side view'},
    {src:'https://cdn.shopify.com/s/files/1/0600/1629/6074/files/LightningMK_Gray03.webp?v=1781579239',alt:'HMP Lightning MK.II in Gray, front view'},
    {src:'https://cdn.shopify.com/s/files/1/0600/1629/6074/files/LightningMK_Gray01.webp?v=1781579237',alt:'HMP Lightning MK.II in Gray, rear view'}
  ]
};

var colorSwatches=[].slice.call(document.querySelectorAll('.flp-color-swatch'));
var activeSwatch=document.querySelector('.flp-color-swatch.flp-active')||colorSwatches[0];
var selectedColor=activeSwatch?activeSwatch.dataset.color:'Black';

var flpColorHero=document.getElementById('flpColorHero');
var flpColorThumbs=document.getElementById('flpColorThumbs');
var lmkBuildThumb=document.getElementById('lmkBuildThumb');
var flpHeroIndex=0;

function renderColorGallery(color){
  var imgs=COLOR_GALLERY[color]||COLOR_GALLERY.Black;
  flpHeroIndex=0;
  if(flpColorHero){flpColorHero.src=imgs[0].src;flpColorHero.alt=imgs[0].alt;}
  if(lmkBuildThumb){lmkBuildThumb.src=imgs[0].src;lmkBuildThumb.alt='HMP Lightning MK.II electric motorcycle in '+color;}
  if(flpColorThumbs){
    flpColorThumbs.innerHTML='';
    flpColorThumbs.style.gridTemplateColumns='repeat('+Math.max(imgs.length,2)+',1fr)';
    imgs.forEach(function(img,i){
      var btn=document.createElement('button');
      btn.type='button';
      btn.className='flp-color-thumb'+(i===0?' flp-active':'');
      btn.setAttribute('aria-label',img.alt);
      var thumbImg=document.createElement('img');
      thumbImg.src=img.src;thumbImg.alt='';thumbImg.loading='lazy';
      btn.appendChild(thumbImg);
      btn.addEventListener('click',function(){
        flpColorThumbs.querySelectorAll('button').forEach(function(b){b.classList.remove('flp-active')});
        btn.classList.add('flp-active');
        flpHeroIndex=i;
        if(flpColorHero){flpColorHero.src=img.src;flpColorHero.alt=img.alt;}
      });
      flpColorThumbs.appendChild(btn);
    });
  }
  if(flpLightbox&&flpLightbox.classList.contains('flp-open')&&!lbSet){lbIndex=0;lbRenderCurrent();}
}

/* ------------------------------------------------------------- lightbox */
var flpLightbox=document.getElementById('flpLightbox');
var flpLightboxImg=document.getElementById('flpLightboxImg');
var flpLightboxStage=document.getElementById('flpLightboxStage');
var flpLightboxClose=document.getElementById('flpLightboxClose');
var flpLightboxPrev=document.getElementById('flpLightboxPrev');
var flpLightboxNext=document.getElementById('flpLightboxNext');
var flpLightboxCounter=document.getElementById('flpLightboxCounter');
var flpGalleryMain=document.getElementById('flpColorGalleryMain');
var lbIndex=0, lbScale=1, lbX=0, lbY=0;
var lbPointers={}, lbStartDist=0, lbStartScale=1, lbLastTap=0;

/* The viewer is shared by the configurator gallery and both photo carousels.
   lbSet is whatever collection was opened last; null falls back to the colour
   gallery so a colour change still re-renders the open viewer correctly. */
var lbSet=null;
function currentGalleryImgs(){return lbSet||COLOR_GALLERY[selectedColor]||COLOR_GALLERY.Black;}
function lbApplyTransform(){if(flpLightboxImg) flpLightboxImg.style.transform='translate('+lbX+'px,'+lbY+'px) scale('+lbScale+')';}
function lbReset(){lbScale=1;lbX=0;lbY=0;lbApplyTransform();}
function lbRenderCurrent(){
  var imgs=currentGalleryImgs();
  if(!imgs.length||!flpLightboxImg) return;
  lbIndex=((lbIndex%imgs.length)+imgs.length)%imgs.length;
  flpLightboxImg.src=imgs[lbIndex].src;
  flpLightboxImg.alt=imgs[lbIndex].alt;
  if(flpLightboxCounter) flpLightboxCounter.textContent=(lbIndex+1)+' / '+imgs.length;
  lbReset();
}
function lbShow(delta){lbIndex+=delta;lbRenderCurrent();}
function openLightbox(index){
  if(!flpLightbox) return;
  lbIndex=typeof index==='number'?index:flpHeroIndex;
  lbRenderCurrent();
  flpLightbox.classList.add('flp-open');
  document.body.classList.add('lmk-lightbox-open');
  document.body.style.overflow='hidden';
}
function closeLightbox(){
  if(!flpLightbox) return;
  flpLightbox.classList.remove('flp-open');
  document.body.classList.remove('lmk-lightbox-open');
  document.body.style.overflow='';
}
if(flpGalleryMain){
  flpGalleryMain.addEventListener('click',function(){lbSet=null;openLightbox(flpHeroIndex);});
  flpGalleryMain.addEventListener('keydown',function(e){if(e.key==='Enter'||e.key===' '){e.preventDefault();lbSet=null;openLightbox(flpHeroIndex);}});
}
if(flpLightboxClose) flpLightboxClose.addEventListener('click',closeLightbox);
if(flpLightboxPrev) flpLightboxPrev.addEventListener('click',function(){lbShow(-1)});
if(flpLightboxNext) flpLightboxNext.addEventListener('click',function(){lbShow(1)});
if(flpLightbox){
  flpLightbox.addEventListener('click',function(e){if(e.target===flpLightbox){closeLightbox();}});
  document.addEventListener('keydown',function(e){
    if(!flpLightbox.classList.contains('flp-open')) return;
    if(e.key==='Escape') closeLightbox();
    if(e.key==='ArrowLeft') lbShow(-1);
    if(e.key==='ArrowRight') lbShow(1);
  });
  if(flpLightboxStage){
    flpLightboxStage.addEventListener('wheel',function(e){
      e.preventDefault();
      lbScale=Math.min(4,Math.max(1,lbScale+(e.deltaY<0?0.18:-0.18)));
      if(lbScale===1){lbX=0;lbY=0;}
      lbApplyTransform();
    },{passive:false});
    flpLightboxStage.addEventListener('pointerdown',function(e){
      flpLightboxStage.setPointerCapture(e.pointerId);
      lbPointers[e.pointerId]={x:e.clientX,y:e.clientY};
      var ids=Object.keys(lbPointers);
      if(ids.length===2){
        var p1=lbPointers[ids[0]],p2=lbPointers[ids[1]];
        lbStartDist=Math.hypot(p2.x-p1.x,p2.y-p1.y);
        lbStartScale=lbScale;
      }
    });
    flpLightboxStage.addEventListener('pointermove',function(e){
      if(!lbPointers[e.pointerId]) return;
      var prev=lbPointers[e.pointerId];
      var ids=Object.keys(lbPointers);
      if(ids.length===2){
        lbPointers[e.pointerId]={x:e.clientX,y:e.clientY};
        var p1=lbPointers[ids[0]],p2=lbPointers[ids[1]];
        var dist=Math.hypot(p2.x-p1.x,p2.y-p1.y);
        if(lbStartDist>0){
          lbScale=Math.min(4,Math.max(1,lbStartScale*(dist/lbStartDist)));
          if(lbScale===1){lbX=0;lbY=0;}
          lbApplyTransform();
        }
      }else if(ids.length===1&&lbScale>1){
        lbX+=e.clientX-prev.x; lbY+=e.clientY-prev.y;
        lbPointers[e.pointerId]={x:e.clientX,y:e.clientY};
        lbApplyTransform();
      }
    });
    function lbPointerEnd(e){delete lbPointers[e.pointerId];if(Object.keys(lbPointers).length<2) lbStartDist=0;}
    flpLightboxStage.addEventListener('pointerup',lbPointerEnd);
    flpLightboxStage.addEventListener('pointercancel',lbPointerEnd);
    flpLightboxStage.addEventListener('pointerleave',lbPointerEnd);
    flpLightboxStage.addEventListener('dblclick',function(){if(lbScale>1){lbReset();}else{lbScale=2.4;lbApplyTransform();}});
  }
  if(flpLightboxImg){
    flpLightboxImg.addEventListener('click',function(e){
      e.stopPropagation();
      var now=new Date().getTime();
      if(now-lbLastTap<300){if(lbScale>1){lbReset();}else{lbScale=2.4;lbApplyTransform();}}
      lbLastTap=now;
    });
  }
}

/* --------------------------------------------------- build + add-on state */
var addonState={rack:false,key:false};
var addonToggles=[].slice.call(document.querySelectorAll('.flp-addon-toggle'));
var selectedName=document.getElementById('selectedName');
var selectedVariantIdInput=document.getElementById('selectedVariantId');
var buildLines=document.getElementById('buildLines');
var buildLineBike=document.getElementById('buildLineBike');
var buildLineBikePrice=document.getElementById('buildLineBikePrice');
var buildTotal=document.getElementById('buildTotal');
var mainBuyBtnPrice=document.getElementById('flpMainBuyBtnPrice');
var stickyTitle=document.getElementById('stickyTitle');
var stickySub=document.getElementById('stickySub');

function addonPrice(id){var el=document.getElementById(id);return el?Number(el.dataset.price||0):0;}

function refreshBuild(){
  var label='Lightning MK.II — '+selectedColor;
  if(selectedName) selectedName.textContent=label;
  if(buildLineBike) buildLineBike.textContent=label;
  if(buildLineBikePrice) buildLineBikePrice.textContent=money(BIKE_PRICE);

  /* rebuild the accessory lines under the bike line */
  if(buildLines){
    buildLines.querySelectorAll('[data-build-addon]').forEach(function(n){n.remove();});
    addonToggles.forEach(function(t){
      var key=t.dataset.addon;
      if(!addonState[key]) return;
      var row=document.createElement('div');
      row.className='flp-build-line';
      row.setAttribute('data-build-addon',key);
      row.innerHTML='<b>'+t.dataset.name+'</b><span>'+money(Number(t.dataset.price))+'</span>';
      buildLines.appendChild(row);
    });
  }

  var total=BIKE_PRICE+(addonState.rack?addonPrice('addonRack'):0)+(addonState.key?addonPrice('addonKey'):0);
  if(buildTotal) buildTotal.textContent=money(total);
  if(mainBuyBtnPrice) mainBuyBtnPrice.textContent=money(total);
  if(stickyTitle) stickyTitle.textContent='Lightning MK.II — '+money(total);
  if(stickySub) stickySub.textContent=selectedColor+' · Launch price · 56 mph'+(total>BIKE_PRICE?' · incl. accessories':(BIKE_COMPARE>BIKE_PRICE?' · Save $'+(BIKE_COMPARE-BIKE_PRICE)+' at launch':''));
  if(selectedVariantIdInput&&activeSwatch) selectedVariantIdInput.value=activeSwatch.dataset.variant;
}

/* v69: 价格与库存都改由后台数据驱动（做法与 FLASH 落地页一致）。这里把内部状态
   暴露给页尾那段脚本，让它能改价、改售罄状态并触发重算，而不必拆开这个 IIFE。 */
window.__lmkBuild={
  refresh:refreshBuild,
  color:function(){return selectedColor;},
  setBikePrice:function(price,compare){
    if(typeof price==='number'&&price>0){BIKE_PRICE=price;}
    if(typeof compare==='number'&&compare>0){BIKE_COMPARE=compare;}
    refreshBuild();
  }
};

function toggleAddon(toggle){
  var key=toggle.dataset.addon;
  addonState[key]=!addonState[key];
  toggle.classList.toggle('flp-addon-selected',addonState[key]);
  toggle.setAttribute('aria-pressed',addonState[key]?'true':'false');
  refreshBuild();
}
addonToggles.forEach(function(toggle){
  toggle.addEventListener('click',function(e){
    if(e.target.closest('.flp-addon-link')) return; /* let the link navigate */
    toggleAddon(toggle);
  });
  toggle.addEventListener('keydown',function(e){
    if(e.target.closest('.flp-addon-link')) return;
    if(e.key==='Enter'||e.key===' '){e.preventDefault();toggleAddon(toggle);}
  });
});

colorSwatches.forEach(function(swatch){
  swatch.addEventListener('click',function(){
    colorSwatches.forEach(function(s){s.classList.remove('flp-active');s.setAttribute('aria-pressed','false')});
    swatch.classList.add('flp-active');
    swatch.setAttribute('aria-pressed','true');
    activeSwatch=swatch;
    selectedColor=swatch.dataset.color;
    renderColorGallery(selectedColor);
    refreshBuild();
  });
});

/* ------------------------------------------------------------- hero video */
/* Rendering note: the <video> must NOT be the absolutely-positioned element itself.
   Stacked directly under the full-bleed gradient it painted one frame and then
   stopped repainting. The absolute box lives on .lmk-hero-media-box and the video
   sits statically inside it, promoted to its own compositing layer. */
(function(){
  var v=document.getElementById('lmkHeroVideo');
  if(!v) return;
  var heroEl=document.getElementById('top');
  var settled=false;

  /* Always load the native rendition. The master is 1280x720, so Shopify's 720p
     transcode IS full source resolution — there is nothing sharper to serve. The
     480p file is kept only as an automatic recovery path if 720p fails outright;
     it is never chosen up front, on any screen size. */
  v.src=v.dataset.srcHd;

  function alive(){settled=true;v.classList.remove('lmk-video-dead');if(heroEl) heroEl.classList.add('lmk-video-live');}
  function retire(){if(!settled) v.classList.add('lmk-video-dead');}
  /* networkState 2 is NETWORK_LOADING (healthy), 3 is NETWORK_NO_SOURCE. */
  function failedForGood(){return !!v.error||v.networkState===v.NETWORK_NO_SOURCE;}

  v.muted=true; v.defaultMuted=true; v.playsInline=true;
  ['loadeddata','canplay','playing'].forEach(function(ev){v.addEventListener(ev,alive);});
  v.addEventListener('error',function(){
    /* Recovery only: if the native file will not play at all, drop to 480p rather
       than showing a frozen still. Never reached under normal conditions. */
    if(v.src!==v.dataset.srcSd){v.src=v.dataset.srcSd;v.load();v.play().catch(function(){});return;}
    if(failedForGood()) retire();
  });

  function tryPlay(){
    var a=v.play();
    if(a&&typeof a.catch==='function') a.catch(function(){
      var retry=function(){v.play().catch(function(){});};
      document.addEventListener('pointerdown',retry,{once:true});
      document.addEventListener('touchstart',retry,{once:true});
    });
  }
  tryPlay();
  document.addEventListener('visibilitychange',function(){if(!document.hidden&&v.paused) tryPlay();});
  setTimeout(function(){if(!settled&&failedForGood()) retire();},9000);
})();

/* --------------------------------------------------------- range explorer */
(function(){
  var tabs=[].slice.call(document.querySelectorAll('.flp-range-tab'));
  var value=document.getElementById('rangeValue');
  var context=document.getElementById('rangeContext');
  if(!tabs.length||!value||!context) return;
  tabs.forEach(function(tab){
    tab.addEventListener('click',function(){
      tabs.forEach(function(t){t.classList.remove('flp-active');t.setAttribute('aria-pressed','false')});
      tab.classList.add('flp-active');tab.setAttribute('aria-pressed','true');
      if(tab.dataset.model==='city'){
        value.textContent='40–48 MI';
        context.textContent='Estimated range in normal city riding — stop-and-go traffic, hills, a mix of speeds. This is an internal estimate derived from the 3.33 kWh pack, not a published HMP road test.';
      }else{
        value.textContent='62 MI';
        context.textContent='The published maximum range, measured at a steady 30 mph — the standard reference condition used across the category.';
      }
    });
  });
})();

/* ----------------------------------------------------- savings calculator */
var saveMiles=document.getElementById('saveMiles');
var saveGas=document.getElementById('saveGas');
var saveElectric=document.getElementById('saveElectric');
var saveLabor=document.getElementById('saveLabor');
var saveYearsRange=document.getElementById('saveYearsRange');
var saveYears=5;
var ridePresets=[].slice.call(document.querySelectorAll('.flp-ride-preset'));

function updateSavings(){
  if(!saveMiles||!saveGas||!saveElectric) return;
  var weekly=Number(saveMiles.value);
  var miles=weekly*52*saveYears;
  var gasPrice=Number(saveGas.value);
  var electricPrice=Number(saveElectric.value);
  var laborRate=saveLabor?Number(saveLabor.value):130;

  var mpg=80;                  /* 150–160cc gas scooter, SF real-world */
  var lmkKwhPerMile=0.076;     /* 3.33 kWh pack ≈ 44 mi of city riding */
  var gasPartsPerMile=0.018;   /* OEM parts, factory schedule */
  var lmkPartsPerMile=0.004;
  var gasHoursPerMile=0.00059; /* ~0.59 shop-hr / 1,000 mi book time */
  var lmkHoursPerMile=0.00016;

  var g={fuel:miles*gasPrice/mpg, parts:miles*gasPartsPerMile, labor:miles*gasHoursPerMile*laborRate};
  var f={fuel:miles*lmkKwhPerMile*electricPrice, parts:miles*lmkPartsPerMile, labor:miles*lmkHoursPerMile*laborRate};
  g.total=g.fuel+g.parts+g.labor; f.total=f.fuel+f.parts+f.labor;
  var energySavings=Math.max(0,g.fuel-f.fuel);
  var partsSavings=Math.max(0,g.parts-f.parts);
  var laborSavings=Math.max(0,g.labor-f.labor);
  var total=energySavings+partsSavings+laborSavings;
  var monthly=total/(saveYears*12);

  /* Slider read-outs are gone with the sliders — guard, or these throw before
     the result values below ever get written. */
  var _mo=document.getElementById('saveMilesOut'); if(_mo) _mo.textContent=weekly.toLocaleString('en-US')+' miles';
  var _yo=document.getElementById('saveYearsOut'); if(_yo) _yo.textContent=saveYears+' years';
  var _go=document.getElementById('saveGasOut'); if(_go) _go.textContent='$'+gasPrice.toFixed(2)+'/gal';
  var _eo=document.getElementById('saveElectricOut'); if(_eo) _eo.textContent='$'+electricPrice.toFixed(2)+'/kWh';
  var _lo=document.getElementById('saveLaborOut'); if(_lo) _lo.textContent='$'+laborRate+'/hr';
  var _st=document.getElementById('saveTotal'); if(_st) _st.textContent=money(Math.round(total));
  var _saveMonthly=document.getElementById('saveMonthly'); if(_saveMonthly) _saveMonthly.textContent=money(Math.round(monthly));
  var _saveEnergy=document.getElementById('saveEnergy'); if(_saveEnergy) _saveEnergy.textContent=money(Math.round(energySavings));
  var _saveParts=document.getElementById('saveParts'); if(_saveParts) _saveParts.textContent=money(Math.round(partsSavings));
  var _saveLaborSave=document.getElementById('saveLaborSave'); if(_saveLaborSave) _saveLaborSave.textContent=money(Math.round(laborSavings));
  var _saveMilesTotal=document.getElementById('saveMilesTotal'); if(_saveMilesTotal) _saveMilesTotal.textContent=Math.round(miles).toLocaleString('en-US')+' miles';
  var _saveYearsText=document.getElementById('saveYearsText'); if(_saveYearsText) _saveYearsText.textContent=saveYears+' years';
  var pMiles=document.getElementById('saveProfileMiles'); if(pMiles) pMiles.textContent=Math.round(miles).toLocaleString('en-US');
  var pWeekly=document.getElementById('saveProfileWeekly'); if(pWeekly) pWeekly.textContent=weekly.toLocaleString('en-US')+' miles';
  var pYears=document.getElementById('saveProfileYears'); if(pYears) pYears.textContent=saveYears+' years';

  var REF=(function(v){var st=[400,800,1500,2500,4000,6000,9000,14000,20000,30000,45000,70000,110000,170000,260000];for(var i=0;i<st.length;i++){if(v<=st[i])return st[i];}return v;})(g.total);
  function w(v){return Math.max(0.8, v/REF*92)+'%';}
  /* Only a subset of these rows is rendered now, so every write is guarded. */
  ['fuel','parts','labor','total'].forEach(function(key){
    var bg=document.getElementById('bg_'+key); if(bg) bg.style.width=w(g[key]);
    var bf=document.getElementById('bf_'+key); if(bf) bf.style.width=w(f[key]);
    var tg=document.getElementById('bt_'+key+'_g'); if(tg) tg.textContent='Gas '+money(Math.round(g[key]));
    var tf=document.getElementById('bt_'+key+'_f'); if(tf) tf.textContent='Lightning '+money(Math.round(f[key]));
    var cs=document.getElementById('cs_'+key); if(cs) cs.textContent='You keep '+money(Math.round(Math.max(0,g[key]-f[key])));
  });
  setRangeVisual(saveMiles);setRangeVisual(saveGas);setRangeVisual(saveElectric);
  if(saveLabor) setRangeVisual(saveLabor);
  if(saveYearsRange) setRangeVisual(saveYearsRange);
}

[saveMiles,saveGas,saveElectric,saveLabor].forEach(function(input){
  if(!input) return;
  input.addEventListener('input',function(){
    if(input===saveMiles) ridePresets.forEach(function(p){p.classList.toggle('flp-active',Number(p.dataset.miles)===Number(saveMiles.value))});
    updateSavings();
  });
});
if(saveYearsRange){
  saveYearsRange.addEventListener('input',function(){saveYears=Number(saveYearsRange.value);updateSavings();});
}
ridePresets.forEach(function(button){
  button.addEventListener('click',function(){
    if(!saveMiles) return;
    saveMiles.value=button.dataset.miles;
    ridePresets.forEach(function(p){p.classList.remove('flp-active')});
    button.classList.add('flp-active');
    updateSavings();
  });
});

/* ------------------------------------------------------ rider-fit explorer */
var fitHeight=document.getElementById('fitHeight');
var fitPresets=[].slice.call(document.querySelectorAll('.flp-fit-preset'));
/* One reference photo per height band, all shot on the same rig. */
var FIT_PHOTOS={
  62:{src:'https://cdn.shopify.com/s/files/1/0600/1629/6074/files/Lightning-MKII-Rider-Fit-5ft2.webp?v=1785750961',
      alt:'5 foot 2 inch rider seated on the HMP Lightning MK.II with feet down at a stop'},
  67:{src:'https://cdn.shopify.com/s/files/1/0600/1629/6074/files/Lightning-MKII-Rider-Fit-5ft7.webp?v=1785750962',
      alt:'5 foot 7 inch rider seated on the HMP Lightning MK.II with feet down at a stop'},
  72:{src:'https://cdn.shopify.com/s/files/1/0600/1629/6074/files/Lightning-MKII-Rider-Fit-6ft0-corrected.webp?v=1785830776',
      alt:'6 foot rider seated on the HMP Lightning MK.II with feet down at a stop'},
  76:{src:'https://cdn.shopify.com/s/files/1/0600/1629/6074/files/Lightning-MKII-Rider-Fit-6ft4-corrected.webp?v=1785830775',
      alt:'6 foot 4 inch rider seated on the HMP Lightning MK.II with feet down at a stop'}
};

function updateFit(){
  if(!fitHeight) return;
  var h=Number(fitHeight.value);
  var cm=Math.round(h*2.54);

  /* 30.7 in seat — slightly lower than the FLASH's ~31 in, so the bands sit
     a touch more generously. Offset by the fact this is a leg-over motorcycle
     rather than a step-through, which the copy calls out explicitly. */
  /* Banding logic, so it can be re-checked rather than taken on faith:
     inseam is roughly 0.46 x height; the 30.7 in seat sags ~1-1.5 in under a rider,
     and seat width costs another ~1.5 in of effective reach. Flat-footing therefore
     needs about a 31 in inseam, i.e. around 5'8"-5'9". Estimated inseams:
       5'2" ~28.5 in (short by ~2.5) -> tip-toe / one foot
       5'7" ~30.8 in (short by ~0.2) -> balls of both feet, or one foot flat
       6'0" ~33.1 in (clear)         -> flat, held at "mostly" to under-promise
       6'4" ~35.0 in (clear)         -> effortless
     Deliberately conservative: being wrong in the optimistic direction costs a return. */
  var footingTitle='Mostly flat-foot', footingShort='Mostly flat-foot';
  var footingNote='Comfortable for everyday city starts and stops.';
  var posture='Balanced upright', postureNote='Natural reach to the bars with a relaxed knee bend.';
  var use='Daily commuting', useNote='Practical for city riding, errands and delivery shifts.';
  var confidence=76, state='mostly';
  var technique='Either foot or both feet';
  var techniqueNote='Most riders in this range can stabilise the bike with both feet, or use a relaxed one-foot stop.';
  var expectation='Confident everyday fit';
  var expectationNote='This is the sweet spot for a 30.7-inch seat.';
  var summary='At a stop, a rider of this height will <b>usually feel secure and stable, with easy footing on most roads</b>. This is the sweet-spot fit range.';
  var sub='A typical rider around this height should feel confident at stoplights, with an easy reach to the bars and a relaxed upright posture.';

  if(h<=64){
    state='tip'; confidence=27;
    footingTitle='Tip-toe / one-foot stop'; footingShort='Tip-toe';
    footingNote='Most riders here will use one foot firmly down, or both toes.';
    posture='Compact upright'; postureNote='Bar reach should be manageable, but the seat will feel tall.';
    use='Test ride recommended'; useNote='Inseam and stop technique matter more than height alone in this range.';
    technique='One foot down'; techniqueNote='Slide slightly to one side at stops and plant one foot firmly rather than forcing both feet down.';
    expectation='Seat will feel tall'; expectationNote='A real test ride is strongly recommended before ordering.';
    summary='At a stop, a rider of this height will <b>most likely rely on one-foot support or tip-toe contact</b>. The step-through frame helps, but this is not a guaranteed flat-foot fit.';
    sub='It can still work for shorter riders, but stop technique, footwear and inseam make a meaningful difference.';
  }else if(h<=69){
    state='balls'; confidence=55;
    footingTitle='Balls of both feet'; footingShort='Balls of feet';
    footingNote='Partial contact on both sides, or one foot very comfortably down.';
    posture='Neutral upright'; postureNote='Comfortable bar reach with a slightly tighter knee angle.';
    use='City commuting'; useNote='A familiar fit for riders who already feel comfortable on scooters.';
    technique='Both feet partial, or one foot flat'; techniqueNote='Most riders choose between partial contact on both feet or a fully planted one-foot stop.';
    expectation='Manageable with normal scooter technique'; expectationNote='Usually comfortable once the rider is used to one-foot stops.';
    summary='At a stop, a rider of this height will <b>usually get the balls of both feet down, or one foot down very comfortably</b>.';
    sub='A practical fit range for riders stepping across from a scooter or an e-bike.';
  }else if(h<=74){
    state='mostly'; confidence=76;
  }else{
    state='flat'; confidence=h<=75?89:95;
    footingTitle='Flat-foot confidence'; footingShort='Flat-footed';
    footingNote='Easy stoplight support with both feet.';
    posture=h<=76?'Relaxed upright':'Roomy upright';
    postureNote=h<=76?'Open knee angle and an easy reach to the controls.':'Plenty of lower-body room; check knee-to-bar clearance on a test ride.';
    use='Commute + weekend'; useNote='Comfortable for longer rides, a passenger and errands.';
    technique='Both feet flat'; techniqueNote='Riders in this height range should be able to stabilise the bike easily with both feet.';
    expectation='Very easy low-speed confidence'; expectationNote='The bike should feel especially approachable at stops and parking speeds.';
    summary='At a stop, a rider of this height will <b>typically flat-foot with ease</b>. The riding position should feel roomy and relaxed.';
    sub='Riders in this band usually get the most effortless feet-down confidence.';
  }

  document.getElementById('fitHeightOut').innerHTML=inchesToText(h).replace('"','&quot;');
  document.getElementById('fitHeightMetric').textContent=cm+' cm';
  var _fitFootingTitle=document.getElementById('fitFootingTitle'); if(_fitFootingTitle) _fitFootingTitle.textContent=footingTitle;
  var _fitSub=document.getElementById('fitSub'); if(_fitSub) _fitSub.textContent=sub;
  var _fitFootingShort=document.getElementById('fitFootingShort'); if(_fitFootingShort) _fitFootingShort.textContent=footingShort;
  var _fitFootingNote=document.getElementById('fitFootingNote'); if(_fitFootingNote) _fitFootingNote.textContent=footingNote;
  var _fitPosture=document.getElementById('fitPosture'); if(_fitPosture) _fitPosture.textContent=posture;
  var _fitPostureNote=document.getElementById('fitPostureNote'); if(_fitPostureNote) _fitPostureNote.textContent=postureNote;
  var _fitUse=document.getElementById('fitUse'); if(_fitUse) _fitUse.textContent=use;
  var _fitUseNote=document.getElementById('fitUseNote'); if(_fitUseNote) _fitUseNote.textContent=useNote;
  var _fitConf=document.getElementById('fitConfidenceText'); if(_fitConf) _fitConf.textContent='Estimated confidence: '+confidence+'%';
  var _fitSum=document.getElementById('fitSummary'); if(_fitSum) _fitSum.innerHTML=summary;
  var barFill=document.querySelector('.flp-fit-bar-fill'); if(barFill) barFill.style.width=confidence+'%';
  var marker=document.getElementById('fitMarker'); if(marker) marker.style.left=confidence+'%';
  document.querySelectorAll('.flp-fit-contact').forEach(function(card){card.classList.toggle('flp-active',card.dataset.state===state)});
  var tech=document.getElementById('fitTechnique'); if(tech) tech.textContent=technique;
  var techNote=document.getElementById('fitTechniqueNote'); if(techNote) techNote.textContent=techniqueNote;
  var exp=document.getElementById('fitExpectation'); if(exp) exp.textContent=expectation;
  var expNote=document.getElementById('fitExpectationNote'); if(expNote) expNote.textContent=expectationNote;
  var shot=FIT_PHOTOS[h]||FIT_PHOTOS[67];
  var fitImg=document.getElementById('fitRiderImage');
  if(fitImg&&shot){fitImg.src=shot.src;fitImg.alt=shot.alt;}
  fitPresets.forEach(function(btn){
    var isCurrent=Number(btn.dataset.height)===h;
    btn.classList.toggle('flp-active',isCurrent);
    btn.setAttribute('aria-pressed',isCurrent?'true':'false');
  });
}
fitPresets.forEach(function(button){
  button.addEventListener('click',function(){
    if(!fitHeight) return;
    fitHeight.value=button.dataset.height;
    updateFit();
  });
});

/* ------------------------------------------------------- YouTube facades */
/* YouTube validates the embedding page's origin. A file:// preview has no
   valid https origin, so the inline iframe fails with "Error 153". Locally we
   open the real watch page instead; on the live Shopify domain the inline
   embed works normally. */
var lmkIsFileProtocol=(window.location.protocol==='file:');
[].slice.call(document.querySelectorAll('.flp-video-facade')).forEach(function(btn){
  btn.addEventListener('click',function(){
    if(lmkIsFileProtocol){
      if(btn.dataset.watch) window.open(btn.dataset.watch,'_blank','noopener');
      return;
    }
    var embedUrl=btn.dataset.embed; if(!embedUrl) return;
    var frame=btn.closest('.flp-video-frame'); if(!frame) return;
    var iframe=document.createElement('iframe');
    iframe.src=embedUrl;
    iframe.title=btn.getAttribute('aria-label')||'Video';
    iframe.allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture';
    iframe.allowFullscreen=true;
    var sourceTag=frame.querySelector('.flp-video-source');
    frame.innerHTML='';
    frame.appendChild(iframe);
    if(sourceTag) frame.appendChild(sourceTag);
  });
});

/* ------------------------------------------------- carousel image viewer */
/* Each carousel opens the same lightbox with its own image set. The track is a
   horizontal scroller, so a click is only treated as "open" when the pointer
   barely moved — otherwise a drag to scroll would fire the viewer. */
[].slice.call(document.querySelectorAll('#gallery .flp-gallery-track, #gallery-details .flp-gallery-track')).forEach(function(track){
  var figures=[].slice.call(track.querySelectorAll('.flp-gallery-slide'));
  var set=figures.map(function(f){
    var img=f.querySelector('img');
    return {src:img?img.currentSrc||img.src:'',alt:img?img.alt:''};
  }).filter(function(x){return x.src;});
  if(!set.length) return;

  figures.forEach(function(fig,i){
    var img=fig.querySelector('img');
    if(!img) return;
    fig.setAttribute('role','button');
    fig.setAttribute('tabindex','0');
    fig.setAttribute('aria-label','Enlarge: '+(img.alt||'photo'));
    var downX=0,downY=0;
    fig.addEventListener('pointerdown',function(e){downX=e.clientX;downY=e.clientY;});
    fig.addEventListener('click',function(e){
      if(Math.abs(e.clientX-downX)>6||Math.abs(e.clientY-downY)>6) return; /* was a drag */
      lbSet=set; openLightbox(i);
    });
    fig.addEventListener('keydown',function(e){
      if(e.key==='Enter'||e.key===' '){e.preventDefault();lbSet=set;openLightbox(i);}
    });
  });
});

/* --------------------------------------------------------- photo carousel */
[].slice.call(document.querySelectorAll('.flp-gallery-shell')).forEach(function(shell){
  var track=shell.querySelector('.flp-gallery-track');
  var prevBtn=shell.querySelector('.flp-gallery-prev');
  var nextBtn=shell.querySelector('.flp-gallery-next');
  if(!track||!prevBtn||!nextBtn) return;
  function step(){
    var slide=track.querySelector('.flp-gallery-slide');
    return slide?slide.getBoundingClientRect().width+14:320;
  }
  function updateButtons(){
    var max=track.scrollWidth-track.clientWidth-4;
    prevBtn.disabled=track.scrollLeft<=4;
    nextBtn.disabled=track.scrollLeft>=max;
  }
  prevBtn.addEventListener('click',function(){track.scrollBy({left:-step()*2,behavior:'smooth'});});
  nextBtn.addEventListener('click',function(){track.scrollBy({left:step()*2,behavior:'smooth'});});
  track.addEventListener('scroll',updateButtons);
  window.addEventListener('resize',updateButtons);
  updateButtons();
});

/* ------------------------------------------------------------ add to cart */
/* Local preview has no Shopify cart, so the submit handler reports what it
   WOULD add. The Shopify branch mirrors the FLASH page: dispatch the Horizon
   cart-lines-update event first, then POST /cart/add.js with the drawer
   section so the cart drawer re-renders instead of showing its stale
   server-rendered state. */
var flpMainBuyForm=document.getElementById('flpMainBuyForm');
if(flpMainBuyForm){
  flpMainBuyForm.addEventListener('submit',function(e){
    e.preventDefault();
    var btn=document.getElementById('flpMainBuyBtn'); if(!btn||btn.disabled) return;
    var statusEl=btn.querySelector('.flp-buybtn-status');

    var items=[{id:Number(selectedVariantIdInput.value),quantity:1}];
    addonToggles.forEach(function(t){
      if(addonState[t.dataset.addon]) items.push({id:Number(t.dataset.variantId),quantity:1});
    });

    if(lmkIsFileProtocol||!window.fetch){
      var names=['Lightning MK.II — '+selectedColor].concat(
        addonToggles.filter(function(t){return addonState[t.dataset.addon]}).map(function(t){return t.dataset.name})
      );
      btn.classList.add('flp-buybtn-loading');
      if(statusEl) statusEl.textContent='Local preview — would add: '+names.join(' + ');
      setTimeout(function(){btn.classList.remove('flp-buybtn-loading');},2600);
      return;
    }

    btn.disabled=true; btn.classList.add('flp-buybtn-loading');
    if(statusEl) statusEl.textContent='Adding…';

    var deferred={};
    var evPromise=new Promise(function(res,rej){deferred.resolve=res;deferred.reject=rej;});
    evPromise.catch(function(){});
    try{
      var ev=new Event('shopify:cart:lines-update',{bubbles:true,cancelable:true});
      ev.action='add'; ev.promise=evPromise;
      btn.dispatchEvent(ev);
    }catch(err){}

    var sectionIds=[];
    document.querySelectorAll('cart-items-component').forEach(function(el){
      if(el.dataset&&el.dataset.sectionId&&sectionIds.indexOf(el.dataset.sectionId)===-1) sectionIds.push(el.dataset.sectionId);
    });
    var payload={items:items};
    if(sectionIds.length){payload.sections=sectionIds.join(',');payload.sections_url=window.location.pathname;}

    fetch('/cart/add.js',{method:'POST',headers:{'Accept':'application/json','Content-Type':'application/json'},body:JSON.stringify(payload),credentials:'same-origin'})
      .then(function(r){return r.json().then(function(d){return {ok:r.ok,data:d};});})
      .then(function(res){
        if(!res.ok) throw new Error('add failed');
        if(statusEl) statusEl.textContent='Added to cart ✓';
        var sections=(res.data&&res.data.sections)?res.data.sections:null;
        return fetch('/cart.js',{credentials:'same-origin'}).then(function(r){return r.json()}).then(function(cart){
          deferred.resolve({cart:{totalQuantity:cart.item_count},detail:{sections:sections,itemCount:cart.item_count,source:'lightning-landing',didError:false}});
        });
      })
      .catch(function(){
        if(statusEl) statusEl.textContent='Could not add — please try again';
        try{deferred.reject();}catch(err){}
      })
      .then(function(){
        setTimeout(function(){btn.disabled=false;btn.classList.remove('flp-buybtn-loading');},1800);
      });
  });
}

/* ------------------------------------------------------------------ init */
renderColorGallery(selectedColor);
refreshBuild();
updateSavings();
updateFit();
})();



(function(){
  if(window.__lmkStockInit){return;}window.__lmkStockInit=true;
  function init(){
    var el=document.getElementById('flpInventoryData');
    if(!el){return;}
    var inv={};
    try{inv=JSON.parse(el.textContent||'{}');}catch(e){return;}
    var LOW=5;
    var swatches=[].slice.call(document.querySelectorAll('.flp-color-swatch[data-variant]'));
    if(!swatches.length){return;}
    var line=document.querySelector('[data-stock-line]');
    var lineTxt=line?line.querySelector('[data-stock-text]'):null;
    var sticky=document.querySelector('[data-sticky-stock]');
    var buyBtn=document.getElementById('flpMainBuyBtn');
    var addons=[].slice.call(document.querySelectorAll('.flp-addon-toggle[data-variant-id]'));
    var cardPrice=document.querySelector('.lmk-build-price b');
    var cardDel=document.querySelector('.lmk-build-price del');
    var cardSave=document.querySelector('.lmk-build-price span');

    function rec(id){var r=inv[id];return (r&&typeof r==='object')?r:{};}
    function qty(id){
      var n=rec(id).q;
      n=(typeof n==='number')?n:parseInt(n,10);
      return (isFinite(n)&&n>0)?n:0;
    }
    function dollars(cents){
      return (typeof cents==='number'&&cents>0)?Math.round(cents)/100:null;
    }
    function money(v){return '$'+Number(v).toLocaleString('en-US');}
    function label(n){return 'Only '+n+' left';}
    function active(){
      return document.querySelector('.flp-color-swatch.flp-active[data-variant]')||swatches[0];
    }

    /* 整车价：按当前选中的颜色取该变体的价格，写回卡片，并交给主脚本重算
       结算摘要 / Add to Cart 金额 / 吸底条。 */
    function applyBikePrice(){
      var sel=active();
      if(!sel){return;}
      var r=rec(sel.dataset.variant);
      var price=dollars(r.p);
      if(price===null){return;}
      var compare=dollars(r.c);
      var hasCompare=(compare!==null&&compare>price);
      if(cardPrice){cardPrice.textContent=money(price);}
      if(cardDel){
        cardDel.style.display=hasCompare?'':'none';
        if(hasCompare){cardDel.textContent=money(compare);}
      }
      if(cardSave){
        cardSave.style.display=hasCompare?'':'none';
        if(hasCompare){cardSave.textContent='Save '+money(compare-price)+' at launch';}
      }
      if(window.__lmkBuild&&window.__lmkBuild.setBikePrice){
        window.__lmkBuild.setBikePrice(price,hasCompare?compare:price);
      }
    }

    /* 配件价：改 data-price（结算摘要和总价读它）和按钮上的 +$xxx 标签。 */
    function applyAddonPrices(){
      addons.forEach(function(t){
        var price=dollars(rec(t.dataset.variantId).p);
        if(price===null){return;}
        t.dataset.price=String(price);
        var tag=t.querySelector('.flp-addon-price-tag');
        if(tag){tag.textContent='+'+money(price)+'.00';}
      });
    }

    function applyStock(){
      swatches.forEach(function(sw){
        var small=sw.querySelector('small');
        if(!small){return;}
        var n=qty(sw.dataset.variant);
        small.className=(n<=0)?'flp-stock-out':(n<=LOW?'flp-stock-low':'');
        small.textContent=(n<=0)?'Sold out':(n<=LOW?label(n):'In stock');
      });
      var sel=active();
      var colour=(sel&&sel.dataset.color)||'this colour';
      var n=sel?qty(sel.dataset.variant):0;
      if(line){
        if(n<=0){
          line.className='lmk-build-stock flp-stock-on flp-stock-out';
          if(lineTxt){lineTxt.textContent=colour+' is sold out — pick the other colour or join the waitlist.';}
        }else if(n<=LOW){
          line.className='lmk-build-stock flp-stock-on';
          if(lineTxt){lineTxt.textContent=label(n)+' in '+colour;}
        }else{
          line.className='lmk-build-stock';
          if(lineTxt){lineTxt.textContent='';}
        }
      }
      /* 售罄就真的不让加购 —— 只改文案不改状态的话按钮还是能提交。
         表单的 submit 处理器本来就会在 btn.disabled 时直接返回。 */
      if(buyBtn){
        buyBtn.classList.toggle('flp-buybtn-soldout',n<=0);
        buyBtn.disabled=(n<=0);
        buyBtn.setAttribute('aria-disabled',n<=0?'true':'false');
      }
      if(sticky){
        var t=swatches.reduce(function(a,sw){return a+qty(sw.dataset.variant);},0);
        sticky.className=(t<=0)?'flp-stock-out':(t<=LOW?'flp-stock-low':'');
        sticky.textContent=(t<=0)?' · Sold out':(t<=LOW?(' · Only '+t+' left'):'');
      }
    }

    function render(){
      applyAddonPrices();
      applyBikePrice();   /* 内部会调 refreshBuild()，所以要在改完配件价之后 */
      applyStock();       /* refreshBuild() 不碰按钮状态，所以放在最后 */
    }

    /* 配件勾选也会走 refreshBuild()，之后按钮状态要重新盖回去。 */
    addons.forEach(function(t){t.addEventListener('click',function(){setTimeout(applyStock,0);});});
    swatches.forEach(function(sw){sw.addEventListener('click',function(){setTimeout(render,0);});});

    /* 调试版专用：暴露一个改库存的接口，正式版不会用到它。 */
    window.lmkSetStock=function(black,gray){
      var ids=swatches.map(function(sw){return sw.dataset.variant;});
      if(ids[0]&&inv[ids[0]]){inv[ids[0]].q=black;}
      if(ids[1]&&inv[ids[1]]){inv[ids[1]].q=gray;}
      render();
    };
    window.lmkLowThreshold=LOW;
    render();
  }
  if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',init);}else{init();}
})();
